module.exports = ".table tbody tr.openModal:hover {\n  -webkit-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);\n          box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n  color: #646464;\n  cursor: pointer; }\n\n.table tbody tr.openModal {\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n  cursor: pointer; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/billing-control/billing-control/bc-sent-to-juridical/bc-sent-to-juridical.component.scss
// module id = ./src/app/billing-control/billing-control/bc-sent-to-juridical/bc-sent-to-juridical.component.scss
// module chunks = main